// @ts-nocheck
import React from "react";
import { useLocation } from "react-router-dom";
import { PartnerBanner } from "../../components/PartnerBanner";
import { WelcomeBanner } from "../../components/WelcomeBanner";
import { SubBanner } from "../../components/SubBanner";
import { MenuSections } from "../../components/MenuSections";
import { Footer } from "../../components/Footer";

import TravelActivities from '../../components/TravelActivities';
import CarRentalBanner from '../../components/CarRentalBanner';
import ActivitiesPopup from '../../components/ActivitiesPopup';
import CarRentalFloat from '../../components/CarRentalFloat';

const Home = () => {
    const location = useLocation();
    // Set by the QR code on the table, so the banner can name the table the guest is
    // sitting at. Nothing else depends on it.
    const tableId = new URLSearchParams(location.search).get("tableid");

    return (
        <div className="flex-1 bg-slate-50">
            <WelcomeBanner tableId={tableId} />

            <div className="flex-1">
                {/* The menu first: a guest who just scanned a QR code wants the food,
                    not an introduction to the restaurant. */}
                <MenuSections />
                <TravelActivities />
                <CarRentalBanner />
                {/* Everything else reads as a closing note on the way out. */}
                <SubBanner />
                {/* Last: who built it. A guest who liked the menu is the best lead the
                    software side of the business gets. */}
                <PartnerBanner />
            </div>

            <ActivitiesPopup />
            <CarRentalFloat />
            <Footer />
        </div>
    );
};

export default Home;
